import rhinoCore from 'rhino/src/core/core.module';
import * as rnNotificationService from './notification.service';

export default angular.module('rhino.components.notification', [rhinoCore])
  .service(rnNotificationService.name, rnNotificationService.default)
  .name;




// WEBPACK FOOTER //
// ../~/@printos/rhino/src/components/notification/notification.module.js